<template>
  <div @click="show = !show">
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-btn flat slot="activator">
        <v-icon left>message</v-icon>Nachricht senden
      </v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon large>message</v-icon>Nachricht senden
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap="">
                <v-flex xs12>
                  <v-textarea
                    v-model="message"
                    label="Ihre Nachricht"
                    auto-grow
                    required
                    :rules="NachrichttextRules"
                    counter="1000"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" flat @click.native="dialog = false">Abbrechen</v-btn>
          <v-btn
            color="primary"
            @click="fehlermeldenpost()"
            :disabled="block"
            :loading="loading"
          >Absenden</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['betriebID', 'userID', 'anzeige'],
  data () {
    return {
      show: false,
      dialog: false,
      message: '',
      subject: '',
      block: false,
      loading: false,
      email: '',
      valid: false,
      NachrichttextRules: [
        v => !!v || 'Bitte Nachricht eingeben',
        v => (v && v.length <= 1000) || 'Bitte nicht mehr als 1000 Buchstaben verwenden.'
      ]
    }
  },
  methods: {
    fehlermeldenpost () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.block = true

        const daten = {
          firmenkontakt: this.betriebID,
          recipients: this.userID,
          subject: this.anzeige.überschrift,
          message: this.message
        }

        axios.post('/api/v1/nachrichten', daten)
	.then((resp) => {
	// console.log(resp)

  this.fehlertext = ''
  this.betriebID = ''
  this.userID = ''
  this.anzeige.überschrift = ''
  this.message = ''

  this.$store.dispatch('responseMessage', {
    type: 'success',
    modal: 'true',
    title: 'Nachricht gesendet ',
    text: 'Der Anbieter wurde per E-Mail kontaktiert!'
  })
  this.dialog = false
  this.loading = false
		// this.block = true
})
	.catch((resp) => {
	// console.log('error: ')
	//   console.log(resp);
  this.$store.dispatch('responseMessage', {
    type: 'error',
    modal: 'false',
    text: 'Konnte Nachricht nicht senden.'
  })
  this.loading = false
})
      };
    }
  },
  computed: {

  }

}

</script>
<style>
</style>